export class SearchPageClearFiltersEvent {
    static EventType = 'SearchPageClearFiltersEvent';
    timestamp = new Date();
    eventType = SearchPageClearFiltersEvent.EventType;
    filters;
    constructor(filters) {
        this.filters = filters;
    }
    static is(event) {
        return event.eventType === SearchPageClearFiltersEvent.EventType;
    }
}
//# sourceMappingURL=SearchPageClearFilterEvent.js.map